export default __webpack_public_path__ + "static/homesense-b8bf6740c974a9563d1d6618df49fdf6.png";